import { Outlet } from 'react-router-dom';
import { CanvisProvider } from '@/pages/administracio/marc/canvis';
import { useAuth } from '@/auth/AuthContext';
import { useMe } from '@/permisos/MeContext';
import { Carregant, ErrorCarrega } from '@/pages/EstatsPagina';
import { AvisosTempsReal } from './AvisosTempsReal';
import { Sidebar } from './Sidebar';
import { OnboardingTelefon } from './TelefonMobil';

export function AppLayout() {
  const { me, carregant, error, reintenta } = useMe();
  const { logout } = useAuth();
  if (carregant) return <Carregant />;
  if (error || !me) return <ErrorCarrega onReintenta={reintenta} onSurt={() => void logout()} />;
  return (
    <CanvisProvider>
      <div className="app">
        <Sidebar />
        <main className="main">
          <Outlet />
        </main>
        <AvisosTempsReal />
        {me.telefonConfirmat === false ? <OnboardingTelefon /> : null}
      </div>
    </CanvisProvider>
  );
}
